import axios from 'axios';
import memoize from 'lodash/memoize';
import { from } from 'rxjs';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { map } from 'rxjs/operators';
import { WORKSPACES, MENU_LINK_TYPES } from '../../constants';
import { setTokenAsCacheKey } from '../utils/memoizeUtils';

const formatLink = ({ link, type }) => {
  if (type === MENU_LINK_TYPES.WORKSPACE) {
    return WORKSPACES[link] || '';
  }
  try {
    return link == null ? link : decodeURIComponent(link);
  } catch (e) {
    return '';
  }
};

export const formatLinks = (menuLinks) =>
  menuLinks.map((menuLink) => ({
    ...menuLink,
    link: formatLink(menuLink),
    options: menuLink.options.map((option) => ({
      ...option,
      link: formatLink(option)
    }))
  }));

/* istanbul ignore next */
const fetchMenuLinks = () =>
  fromPromise(axios.post('/infrastructure/menu/getUserMenu'))
    .pipe(
      map(({ data: { data } }) => data),
      map(formatLinks)
    );

export default fetchMenuLinks;
